@if(refI.indexActive > -1){
<menu class="h-[59px] w-screen fixed z-[98] top-[34px] px-3 sm:px-5 md:px-[60px] 2xl:px-[131px]">
    <div class="w-full select-none relative">
        <div class="w-full">
            <div
                class="w-full px-2 sm:px-10 h-[59px] whitespace-nowrap rounded-full bg-white shadow-lg backdrop-blur-md flex items-center">
                <img (click)="refI.indexActive = 0;goTo('')" class="cursor-pointer" src="assets/logo.svg"
                    style="height: 30px; width: auto;" alt="Innovation Smart Plaza"> 
                <div (click)="refI.indexActive = 0;goTo('')"
                    class="text-[#719CFF] cursor-pointer text-font20px ml-2.5 font-bold">Innovation Smart Plaza
                </div>
                @if(refI.indexActive != 7){ <div
                    class="hidden aspect43:flex items-center ml-auto text-[#364349] text-font18px font-bold gap-[23px]">
                    <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 0}"
                        (click)="refI.indexActive = 0;goTo('')">Home</div>
                    <std-click-outside (clickOutside)="showBandiMenu = false">
                        <std-tooltip position="bottom"
                            classTooltip="!w-fit bg-white shadow-xl border-[1px] border-gray-200 rounded-lg py-2"
                            [show]="showBandiMenu">

                            <div content class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 9}"
                                (click)="toggleAndNavigate()">Ricerca bandi</div>

                            <div tooltip>
                                <div class="flex flex-col gap-2">
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando')">
                                        Tutti i bandi</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/innovazione-ricerca')">
                                        Innovazione & Ricerca</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/digitale-intelligenza-artificiale')">
                                        Digitale & Intelligenza Artificiale</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/green-transizione-ecologica')">
                                        Green & Transizione Ecologica</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/startup-nuove-imprese')">
                                        Startup & Nuove Imprese</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/investimenti-beni-strumentali')">
                                        Investimenti & Beni Strumentali</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/mezzogiorno-aree-agevolate')">
                                        Mezzogiorno & Aree Agevolate</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToCategory('cerca-bando/export-internazionalizzazione')">
                                        Export & Internazionalizzazione</div>
                                </div>
                            </div>
                        </std-tooltip>
                    </std-click-outside>
                    <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 1}"
                        (click)="refI.indexActive = 1;goTo('chi-siamo')">Chi siamo</div>
                    <!-- <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 2}"
                        (click)="refI.indexActive = 2;goTo('servizi')">Servizi</div> -->
                    <std-click-outside (clickOutside)="showPianiMenu = false">
                        <std-tooltip position="bottom"
                            classTooltip="!w-fit bg-white shadow-xl border-[1px] border-gray-200 rounded-lg py-2"
                            [show]="showPianiMenu">

                            <div content class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 8}"
                                (click)="togglePianiMenu()">Piani</div>

                            <div tooltip>
                                <div class="flex flex-col gap-2">
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToPiano('piani')">
                                        Imprese e Startup</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToPiano('piani/enti-pubblici')">
                                        Enti Pubblici</div>
                                    <div class="cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-sm" (click)="navigateToPiano('piani/partner')">
                                        Partner</div>
                                </div>
                            </div>
                        </std-tooltip>
                    </std-click-outside>

                    <!-- <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 3}"
                        (click)="refI.indexActive = 3;goTo('news')">News</div> -->
                    <!-- <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 4}"
                        (click)="refI.indexActive = 4;goTo('dicono-di-noi')">Dicono di noi</div> -->
                    <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 99}"
                        (click)="refI.indexActive = 99;goToBlog()">Blog</div>
                    <!-- <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 5}"
                        (click)="refI.indexActive = 5;goTo('unisciti-al-team')">Unisciti al team</div> -->
                    <div class="cursor-pointer" [ngClass]="{'text-[#719CFF]': refI.indexActive == 6}"
                        (click)="refI.indexActive = 6;goTo('contatti')">Contatti</div>

                    <div *ngIf="!showLogout" (click)="goToRegister()" class="ml-4 cursor-pointer bg-quintary text-white h-[39px] px-4 rounded-full flex items-center justify-center text-font16px font-bold hidden aspect43:flex">
                    Registrati gratuitamente    
                    </div>
                    
                    <img class="cursor-pointer" (click)="changeIntoManager()" src="../../assets/loginIcon.svg" alt="Login" />
                    @if(showLogout){

                    <svg class="cursor-pointer" (click)="logout()" _ngcontent-ng-c2551352382=""
                        xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 17 17" fill="none">
                        <path _ngcontent-ng-c2551352382=""
                            d="M10.204 5.7987V4.54843C10.204 4.21684 10.0723 3.89882 9.8378 3.66435C9.60333 3.42988 9.28532 3.29816 8.95373 3.29816H2.95242C2.62083 3.29816 2.30282 3.42988 2.06834 3.66435C1.83387 3.89882 1.70215 4.21684 1.70215 4.54843V12.0501C1.70215 12.3817 1.83387 12.6997 2.06834 12.9341C2.30282 13.1686 2.62083 13.3003 2.95242 13.3003H8.95373C9.28532 13.3003 9.60333 13.1686 9.8378 12.9341C10.0723 12.6997 10.204 12.3817 10.204 12.0501V10.7998"
                            stroke="var(--quaternary)" stroke-width="1.00189" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path _ngcontent-ng-c2551352382="" d="M12.2051 5.79884L14.706 8.29975L12.2051 10.8006"
                            stroke="var(--quaternary)" stroke-width="1.00189" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path _ngcontent-ng-c2551352382="" d="M6.17261 8.29944H14.7057" stroke="var(--quaternary)"
                            stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    }
                </div>}
                <!-- @if(refI.indexActive == 7){
                    <div (click)="changeAccess()" class="ml-auto mr-2.5 text-quaternary text-font18px font-semibold cursor-pointer">Accedi / Registrati</div>
                } -->
                <div class="ml-auto mr-[5px] aspect43:hidden cursor-pointer overflow-hidden" (click)="activateMenu()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.00098 18.0002H21.001V16.0001H3.00098V18.0002ZM3.00098 13.0001H21.001V11.0004H3.00098V13.0001ZM3.00098 6.00024V8.00039H21.001V6.00024H3.00098Z"
                            fill="#1F299C" />
                    </svg>

                </div>
            </div>

        </div>
        @if (showMenu) {
        <div
            class="transition-all aspect43:hidden w-full bg-white absolute top-0 z-[96] overflow-y-auto animation-open-menu custom-scrollbar rounded-[30px]"
            [ngClass]="{'animation-close-menu': closeMenu}" style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.16)">
            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer mt-4"
                (click)="refI.indexActive = 0;goTo('')">
                Home</div>

            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer"
                (click)="isBandiMobileOpen = !isBandiMobileOpen">
                Ricerca bandi</div>

            @if (isBandiMobileOpen) {
            <div class="flex flex-col items-center gap-4 py-4 mb-[22px] bg-[#F1F5FF] animate-in fade-in slide-in-from-top-2 duration-300">
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando')">Tutti i bandi</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/innovazione-ricerca')">Innovazione & Ricerca</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/digitale-intelligenza-artificiale')">Digitale & IA</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/green-transizione-ecologica')">Green & Transizione</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/startup-nuove-imprese')">Startup & Nuove Imprese</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/investimenti-beni-strumentali')">Investimenti & Beni</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/mezzogiorno-aree-agevolate')">Mezzogiorno & Aree</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToCategory('cerca-bando/export-internazionalizzazione')">Export & Internaz.</div>
            </div>
            }

            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer"
                (click)="refI.indexActive = 1;goTo('chi-siamo')">
                Chi siamo</div>

            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer"
                (click)="isPianiMobileOpen = !isPianiMobileOpen">
                Piani</div>

            @if (isPianiMobileOpen) {
            <div class="flex flex-col items-center gap-4 py-4 mb-[22px] bg-[#F1F5FF] animate-in fade-in slide-in-from-top-2 duration-300">
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToPiano('piani')">Imprese e Startup</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToPiano('piani/enti-pubblici')">Enti Pubblici</div>
                <div class="text-font16px text-[#364349] cursor-pointer hover:text-[#719CFF]" (click)="navigateToPiano('piani/professionisti')">Partner</div>
            </div>
            }


            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer"
                (click)="refI.indexActive = 99;goToBlog()">Blog</div>

            <div class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer"
                (click)="refI.indexActive = 6;goTo('contatti')">
                Contatti</div>

            <div (click)="changeIntoManager()"
                class="text-[#364349] text-font20px font-semibold mx-auto mb-[22px] flex place-content-center cursor-pointer">
                Profilo</div>
        </div>
        }

    </div>

</menu>}